import { withInstall, withNoopInstall } from '@jdesign-vue/utils'
import Statistic from './src/statistic.vue'
import StatisticGroup from './src/statistic-group.vue'

export const JdStatistic = withInstall(Statistic, {
  StatisticGroup,
})

export default JdStatistic
export const JdStatisticGroup = withNoopInstall(StatisticGroup)

export * from './src/statistic'
export * from './src/statistic-group'
export * from './src/constants'
